import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  queryLabel: {
    id: 'studio.rWPtv+',
    defaultMessage: 'Query parameter',
  },
  queryHelp: {
    id: 'studio.GNZzUE',
    defaultMessage: 'The query parameter for query parameter authentication',
  },
  secretLabel: {
    id: 'studio.CtZMCP',
    defaultMessage: 'Secret',
  },
  secretHelp: {
    id: 'studio.0agQte',
    defaultMessage: 'The secret for query parameter authentication',
  },
});
